export const marginBottom = '1rem'
export const componentMaxWidth = '800px'
